// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"drnjG","rc-tabs-tab-active":"PUaLj","input-suffix":"wv-4t","nav-item":"pEC14"};